const ONE_DAY = 1 * 24 * 60 * 60 * 1000;
const ONE_YEAR = 365 * ONE_DAY; // we simply use 365 days for one year.
// 2019-02-27 15:04:00 +0800
// this format come from backend, so we need parse custom format
const dateFormat = /^(\d{4}-\d\d-\d\d) (\d\d:\d\d:\d\d) (\+\d{2})(\d{2})$/;

/* eslint-disable consistent-return */
export const parseTimeStamp = (datetime) => {
  try {
    if (typeof datetime === 'number') {
      const UTCtime = new Date(datetime).toISOString();

      return Date.parse(UTCtime);
    }

    const matchs = datetime.match(dateFormat);

    return Date.parse(`${matchs[1]}T${matchs[2]}${matchs[3]}:${matchs[4]}`);
  } catch (error) {
    console.error('parseTimeStamp error', {
      datetime,
      error,
    });
  }
};

export const parseDate = (datetime) => new Date(parseTimeStamp(datetime));

const getNow = () => new Date();
const startOfTodayInUnixTime = () => {
  const now = getNow();
  const nextMonth = (now.getMonth() + 1).toString().padStart(2, '0');

  return new Date(
    `${now.getFullYear()}-${nextMonth}-${now.getDate()}`
  ).getTime();
};
const startOfYesterdayInUnixTime = startOfTodayInUnixTime() - ONE_DAY;

export const getTime = (datetime) => {
  const date = parseDate(datetime);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, 0);

  return {
    hours,
    minutes,
  };
};

export const isToday = (datetime) => {
  const date = parseDate(datetime);
  const now = getNow();

  return (
    now.getFullYear() === date.getFullYear() &&
    now.getMonth() === date.getMonth() &&
    now.getDate() === date.getDate()
  );
};

export const isYesterday = (datetime) => {
  const date = parseDate(datetime);

  return (
    date.getTime() < startOfTodayInUnixTime() &&
    date.getTime() >= startOfYesterdayInUnixTime
  );
};

export const isBeforeYesterday = (datetime) => {
  const date = parseDate(datetime);

  return date.getTime() < startOfYesterdayInUnixTime;
};

export const isBeforeOneYear = (datetime) => {
  const date = parseDate(datetime);
  const startOfOneYearAgo = startOfTodayInUnixTime() - ONE_YEAR;

  return date.getTime() < startOfOneYearAgo;
};



// WEBPACK FOOTER //
// ./src/utils/datetimeformator.js